<div class="row p-2" [innerHTML]="body">

</div>
